module.exports = __webpack_public_path__ + "static/media/features-customized-color.a93c77c5.png";